import React from "react";
import EightPointChecklistGangMemberSign from "./EightPointChecklistGangMemberSign";
import { PermitGangMember } from "../models/PermitGangMember";
import { Permit } from "../models/Permit";
import { GangMemberSignature } from "../models/GangMemberSignature";
import {
    canDeleteGangMember,
    canMarkGangMemberAbsent,
    canUndoGangMemberAbsence,
} from "../containers/EightPointChecklistTabContainer/permitGangMemberService";

interface EightPointChecklistGangMembersProps {
    permit: Permit;
    dateFrom: Date;
    dateTo: Date;
    onPermitGangMemberDeleted: (permitGangMember: PermitGangMember) => void;
    onMarkGangMemberAsAbsent: (permitGangMember: PermitGangMember) => void;
    onUndoGangMemberAbsence: (permitGangMember: PermitGangMember) => void;
    onGangMemberSignatureSubmitted: (
        permitGangMemberId: string,
        signature: GangMemberSignature,
        signatureDataUrl: string
    ) => void;
    isReadOnly?: boolean;
}

const EightPointChecklistGangMembers: React.FC<EightPointChecklistGangMembersProps> = ({
    permit,
    dateFrom,
    dateTo,
    onPermitGangMemberDeleted,
    onMarkGangMemberAsAbsent,
    onUndoGangMemberAbsence,
    onGangMemberSignatureSubmitted,
    isReadOnly,
}) => {
    const renderPermitGangMember = (permitGangMember: PermitGangMember) => {
        return (
            <EightPointChecklistGangMemberSign
                permitId={permit.id}
                dateFrom={dateFrom}
                dateTo={dateTo}
                key={permitGangMember.id}
                permitGangMember={permitGangMember}
                onGangMemberSignatureSubmitted={onGangMemberSignatureSubmitted}
                onPermitGangMemberDeleted={onPermitGangMemberDeleted}
                onMarkGangMemberAsAbsent={onMarkGangMemberAsAbsent}
                onUndoGangMemberAbsence={onUndoGangMemberAbsence}
                isReadOnly={isReadOnly}
                canDeleteGangMember={canDeleteGangMember(permitGangMember, permit.status)}
                canMarkGangMemberAbsent={canMarkGangMemberAbsent(permitGangMember, permit.status)}
                canUndoGangMemberAbsence={canUndoGangMemberAbsence(permitGangMember, permit.status)}
            />
        );
    };

    return <>{permit.permitGangMembers.map((g) => !g.pendingDelete && !g.deleted && renderPermitGangMember(g))}</>;
};

export default EightPointChecklistGangMembers;
